import React from 'react';
import { Sprout } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Alert } from '@/components/ui/alert';
import { Label } from '@/components/ui/label';
import { CategoryItem, SectionState } from '@/types/admin';

interface SeedManagementSectionProps {
  categories: CategoryItem[];
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  newSeeds: string;
  setNewSeeds: (seeds: string) => void;
  seedSection: SectionState;
  handleAddSeeds: () => void;
}

const SeedManagementSection: React.FC<SeedManagementSectionProps> = ({
  categories,
  selectedCategory,
  setSelectedCategory,
  newSeeds,
  setNewSeeds,
  seedSection,
  handleAddSeeds
}) => {
  return (
    <Card className="border-none shadow-none bg-transparent">
      <CardContent className="px-0">
        <div className="space-y-4 max-w-2xl">
          <div className="space-y-2">
            <Label>Category</Label>
            <Select
              value={selectedCategory}
              onValueChange={setSelectedCategory}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select a category" />
              </SelectTrigger>
              <SelectContent>
                {categories.map((category) => (
                  <SelectItem key={category.name} value={category.name}>
                    {category.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Seeds</Label>
            <Textarea
              value={newSeeds}
              onChange={(e) => setNewSeeds(e.target.value)}
              className="min-h-[150px]"
              placeholder="Enter seeds (one per line)"
            />
          </div>

          {seedSection.error && (
            <Alert variant="destructive">
              {seedSection.error}
            </Alert>
          )}

          {seedSection.success && (
            <Alert className="border-green-200 bg-green-50 text-green-800 dark:bg-green-900/20 dark:border-green-800 dark:text-green-300">
              {seedSection.success}
            </Alert>
          )}

          <div className="flex justify-end">
            <Button
              onClick={handleAddSeeds}
              className="bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
              disabled={!selectedCategory || !newSeeds.trim()}
            >
              <Sprout className="h-4 w-4 mr-2" />
              Add Seeds
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SeedManagementSection;
